import { render, staticRenderFns } from "./ReserveChange.vue?vue&type=template&id=733e956a&scoped=true"
import script from "./ReserveChange.vue?vue&type=script&lang=js"
export * from "./ReserveChange.vue?vue&type=script&lang=js"
import style0 from "./ReserveChange.vue?vue&type=style&index=0&id=733e956a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733e956a",
  null
  
)

export default component.exports